import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm, Field, Form } from 'redux-form';

import { TextField } from 'common/components/forms';
import { FormErrorNoRouter } from 'common/components/layout';
import { forgotPassword } from 'redux/customer/actions';

import { validateForgotPassword } from './validators';

class ForgotPasswordWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMessage: null
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    const { redirectLink } = this.props;
    const data = transformData(form);
    const successFunction = () => {
      this.setState({ showMessage: 'Success' });
    };
    const errorFunction = () => {
      this.setState({ showMessage: 'Error' });
    };
    data.redirectLink = redirectLink;
    props.forgotPassword(data, successFunction, errorFunction);
    props.reset();
  };

  handleChange = () => {
    this.setState({ showMessage: null });
  };

  handleLogin = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onLogin();
  };

  render() {
    const { handleSubmit, form } = this.props;
    const { showMessage } = this.state;
    const { redirectLink, loginLink } = this.props;
    return (
      <>
        {showMessage === 'Success' && (
          <div className="c7-message--success">
            A reset password email has been sent to your email account. The link
            expires in 4 hours so be sure to use it soon.
          </div>
        )}
        {showMessage === 'Error' && (
          <div className="c7-message--error">
            Error: No account found with that email
          </div>
        )}
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <FormErrorNoRouter formName={form} />
          <Field
            name="email"
            label="Email"
            component={TextField}
            formType="email"
            autocomplete="email"
            onChange={this.handleChange}
            required
          />
          <div>
            <button type="submit" className="c7-button">
              Reset Password
            </button>
          </div>
        </Form>

        <p>
          <Link to={{ pathname: loginLink, state: { redirectLink } }}>
            Return to login
          </Link>
        </p>
      </>
    );
  }
}

const transformData = (values) => {
  const data = {
    email: values.email
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateForgotPassword(data);
  return errors;
};

ForgotPasswordWidget = reduxForm({
  form: 'forgotPassword',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(ForgotPasswordWidget);

export default connect(null, {
  forgotPassword
})(ForgotPasswordWidget);
